// extracted by mini-css-extract-plugin
module.exports = {"message":"_1JfbyJQ37pls96BzbncfSA"};